
import RcDomainObject from "@/domain/common/RcDomainObject.js";
//import Vehicle from "@/domain/model/vehicle/Vehicle.js";

//import Catalog from "@/domain/session/Catalog.js";

//import StringUtils from '@/utils/StringUtils.js';
//import ConstUtils from '@/utils/ConstUtils.js';

export default class Note extends RcDomainObject {
  
  static MODEL_NAME = "VehicleScheduleQuestionNote";
  
  static Fields = {
    VALUE: 'value',
    POSITION: 'position',
  }
  
  static Values = {
      
  }
  
  constructor(domain, data) {
    super(domain, data, Note.MODEL_NAME);
  }

  find() {
    return this.domain.notes().findById(this.id());
  }
  
  position() {
    return this.getString(Note.Fields.POSITION);
  }
  
  value() {
    return this.getString(Note.Fields.VALUE);
  }
  
  withPosition(position) {
    this.put(Note.Fields.POSITION, position);
    return this;
  }
  
  withValue(value) {
    this.put(Note.Fields.VALUE, value);
    return this;
  }
  
  // Whether the note says anything: a value that is only blanks, or null as a read
  // returns it when never set, counts as empty.
  hasValue() {
    return this.value().trim() !== '';
  }
  
  // The position as a number for ordering, "2" before "10"; one that is not a number
  // sorts last.
  positionNumber() {
    var number = parseInt(this.position(), 10);
    return isNaN(number) ? Number.MAX_SAFE_INTEGER : number;
  }
  
  copy() {
    var data = this._copy();
    return new Note(this.domain, data);
  }
}